import { render, staticRenderFns } from "./DealershipsList.vue?vue&type=template&id=3343d329&scoped=true"
import script from "./DealershipsList.vue?vue&type=script&lang=ts"
export * from "./DealershipsList.vue?vue&type=script&lang=ts"
import style0 from "./DealershipsList.vue?vue&type=style&index=0&id=3343d329&prod&lang=scss&scoped=true"
import style1 from "./DealershipsList.vue?vue&type=style&index=1&id=3343d329&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3343d329",
  null
  
)

export default component.exports